import React, { FC, useState } from 'react';
import StaticProductDetailsModal from '../../StaticLineTable/StaticProductDetailsModal';
import styles from './DpDetailsModal.module.scss';
import { FALCONDESCRIPTION, SPACER, FALCONDESCRIPTIONLIST } from '../../../utils/constants';
import FalconAccordionList from '../../FalconAccordionList';
import FalconDescription from '../../FalconDescription/FalconDescription';
import Spacer from '../../Spacer/Spacer';
import Row from '../../ResponsiveRow/row';

const DpDetailsModal: FC<any> = ({
  content,
  showProductDetail,
  setShowProductDetail,
  priceSection,
  addToCartButton,
  priceDuration
}) => {
  const [modalState, setModalState] = useState(true);
  let falconBody: any = [],
    backBtn = '';
  content &&
    content.length > 0 &&
    content?.map((e: any) => {
      falconBody = e?.modalBody;
      backBtn = e?.backButton;
    });

  const handleClick = () => {
    setModalState(!modalState);
    setShowProductDetail(!showProductDetail);
  };

  return (
    <>
      <StaticProductDetailsModal
        modalState={modalState}
        handler={handleClick}
        showFooter={false}
        height={'100%'}
        backButton={backBtn}
      >
        <>
          {falconBody?.map((ele: any, index: number) => (
            <Row>
              <>
                {ele?.component === FALCONDESCRIPTION && (
                  <FalconDescription content={ele} key={index} />
                )}
                {ele?.component === SPACER && <Spacer content={ele} />}
                {ele?.component === FALCONDESCRIPTIONLIST && <FalconAccordionList content={ele} />}
              </>
            </Row>
          ))}
          {typeof priceSection == 'function' || typeof addToCartButton == 'function' ? (
            <div className={`footer-main ${styles['check-footer']} `}>
              <span className={`${styles['footer-linetablev3']}`}>
                {typeof priceSection == 'function' && (
                  <div>
                    {priceSection()}
                    {priceDuration && <>{priceDuration}</>}
                  </div>
                )}
                {typeof addToCartButton == 'function' && (
                  <div className={styles.cartbtn}>{addToCartButton()}</div>
                )}
              </span>
            </div>
          ) : (
            ''
          )}
        </>
      </StaticProductDetailsModal>
    </>
  );
};
export default DpDetailsModal;
